import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { take, map, tap } from 'rxjs/operators';
import { AuthService } from '../services/api/auth.service';
import { ROUTES } from '@app/infrastructure/utils/constants';

@Injectable({
  providedIn: 'root',
})
export class LoggedInCheckGuard {
  private lastSuccessfulCheck: Date = null;
  constructor(private router: Router, private authService: AuthService) {}

  public canActivate(): Observable<boolean> {
    if (this.lastSuccessfulCheck && !this.hasMinuteGoneBy()) return of(true);
    return this.authService.check().pipe(
      take(1),
      tap((isLoggedInUser) => {
        if (!isLoggedInUser) {
          this.router.navigateByUrl(`/${ROUTES.auth.root}`);
        } else {
          this.lastSuccessfulCheck = new Date();
        }
      }),
    );
  }

  public canActivateChild(): Observable<boolean> {
    return this.canActivate();
  }

  private hasMinuteGoneBy() {
    const now = new Date();
    const timeDifference = now.getTime() - this.lastSuccessfulCheck.getTime();
    return timeDifference > 60000;
  }
}
